/* eslint-disable max-classes-per-file */
// https://sondermind-jira.atlassian.net/browse/PE-27267

import {
  Component, HostBinding, Input, EventEmitter, OnDestroy, Optional, SkipSelf, OnChanges, SimpleChanges
} from '@angular/core';

import { takeUntil } from 'rxjs/operators';

import { BreakpointsService } from '@sondermind/utilities/services';

@Component({
  selector: 'sm-cl-separator',
  template: `<!-- hi -->`,
  standalone: false
})
export class CardLayoutSeparatorComponent {
  @HostBinding('class.sm-cl-separator')
    bindComponentClass = true;
}

@Component({
  selector: 'sm-cl-item',
  template: '<ng-content></ng-content>',
  standalone: false
})
export class CardLayoutItemComponent implements OnDestroy {
  private destroyed$ = new EventEmitter<void>();

  constructor(
    breakpoints: BreakpointsService
  ) {
    // make us mobile aware
    breakpoints.isMobile$
      .pipe(takeUntil(this.destroyed$))
      // eslint-disable-next-line no-return-assign
      .subscribe((m) => this.mobile = m);
  }

  @HostBinding('class.sm-cl-item')
    bindComponentClass = true;

  @Input()
  @HostBinding('attr.data-span')
    span: string | number;

  @Input()
  @HostBinding('attr.data-bleed')
    bleed: 'left' | 'right' | 'left right' | 'right left';

  @Input('content-bleed')
  @HostBinding('attr.data-content-bleed')
    contentBleed: string;

  @Input()
  @HostBinding('attr.data-gravity')
    gravity: 'bottom' | 'top';

  @Input()
  @HostBinding('attr.data-align')
    align: 'left' | 'center' | 'right' | 'stretch';

  @Input()
  @HostBinding('attr.data-highlight')
    highlight: boolean | string = false;

  @Input()
  @HostBinding('attr.data-undecorated')
    undecorated = false;

  @Input()
  @HostBinding('attr.data-container')
    container: boolean;

  @HostBinding('attr.data-mobile')
    mobile;

  ngOnDestroy() {
    this.destroyed$.next();
  }
}

@Component({
  selector: 'sondermind-card-layout, sm-cl-layout',
  template: '<ng-content></ng-content>',
  standalone: false
})
export class CardLayoutComponent implements OnChanges, OnDestroy {
  @HostBinding('class.sondermind-card-layout')
  @HostBinding('class.sm-cl-layout')
    bindComponentClass = true;

  @Input()
  @HostBinding('attr.data-maxspan')
    maxspan = 3;

  @Input()
  @HostBinding('attr.data-span')
    span: string | number;

  @Input()
  @HostBinding('attr.data-collapsed')
    collapsed: boolean;

  @Input()
  @HostBinding('attr.data-separated')
    separated = true;

  @Input()
  @HostBinding('attr.data-valign')
    valign: 'center' | 'top' | 'bottom';

  @Input()
  @HostBinding('attr.data-wrap')
    wrap = false;

  changes$ = new EventEmitter<SimpleChanges>();
  destroyed$ = new EventEmitter<void>();

  constructor(
    @SkipSelf() @Optional()
    private parent: CardLayoutComponent
  ) {
    if (this.parent) {
      this.parent.changes$
        .pipe(takeUntil(this.destroyed$))
        .subscribe(this.ngOnChanges.bind(this));
    }
  }

  ngOnChanges(c: SimpleChanges) {
    this.changes$.next(c);

    if (this.parent) {
      this.collapsed = this.parent.collapsed;
      this.separated = this.parent.separated;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}

export const Declarations = [
  CardLayoutComponent,
  CardLayoutItemComponent,
  CardLayoutSeparatorComponent
];
